module.exports = __webpack_public_path__ + "static/media/34DSS6.4342e16f.jpg";